import { render, staticRenderFns } from "./MeterReturnPremiumModal.vue?vue&type=template&id=38cb54c2"
import script from "./MeterReturnPremiumModal.vue?vue&type=script&lang=js"
export * from "./MeterReturnPremiumModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports